import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageMeta from "../../../components/common/PageMeta";
import ComponentCard from "../../../components/common/ComponentCard";
import Button from "../../../components/ui/button/Button";
import CustomerSurveysTable from "./CustomerSurveysTable";
import { jwtDecode } from "jwt-decode";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';

const apiUrl = process.env.REACT_APP_API_URL;

interface MyTokenPayload {
  id: number;
  groupid: number;
  username: string;
  iat?: number;
  exp?: number;
}

const CustomerSurveys = () => {
  const [isTokenLoaded, setIsTokenLoaded] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    dateBefore: "",
    dateAfter: "",
    manager: "",
    venue: "",
  });

  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    // const params = new URLSearchParams(location.search);
    // const sessionid = params.get("token");
    // const token = localStorage.getItem("token");
    // console.log("token from local stogage:", token);

    const fetchSurveys = async () => {
      try {
        setIsTokenLoaded(true); // Mark token as loaded
        
      } catch (err) {
        console.error("Error:", error);
        alert(err || "please login again");
      }
    };
    

    if (token) {
      fetchSurveys();
    } else if (token) {
      setIsTokenLoaded(true);
    } else {
      setError("No session or token found. Please login.");
    }

  }, [location]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const clearFilters = () => {
    setFilters({
      dateBefore: "",
      dateAfter: "",
      manager: "",
      venue: "",
    });
  };

  const handleDateChange = (name: string, date: Date | null) => {
  setFilters((prev) => ({
    ...prev,
    [name]: date ? format(date, 'yyyy-MM-dd') : '',
  }));
};


  return (
    <>
      <PageMeta
        title="Customer Surveys"
        description="This is the Customer Surveys page"
      />
      <div className="space-y-6">
        <ComponentCard title="Customer Surveys">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">Customer Surveys</div>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                onClick={() => setShowFilters((prev) => !prev)}
                className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium text-[#ffffed] rounded-lg bg-[#142900] hover:bg-[#e1ffb4] hover:text-[#142900]"
              >
                Filter Options
              </button>
              <Button
                className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]"
                size="sm"
                onClick={() => navigate("/add-new-survey")}
              >
                Add New Survey
              </Button>
            </div>
          </div>
         
          {showFilters && (
          <div className="flex flex-col gap-2 px-4 py-4 border border-b-0 border-gray-100 dark:border-white/[0.05] rounded-t-xl sm:flex-row">
            <div className="flex flex-wrap gap-2">
              <div>
                <label className="block text-sm font-medium text-gray-700">Start Date</label>
                <DatePicker
                  selected={filters.dateAfter ? new Date(filters.dateAfter) : null}
                  onChange={(date) => handleDateChange('dateAfter', date)}
                  dateFormat="yyyy-MM-dd"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  placeholderText="Select start date"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">End Date</label>
                <DatePicker
                  selected={filters.dateBefore ? new Date(filters.dateBefore) : null}
                  onChange={(date) => handleDateChange('dateBefore', date)}
                  dateFormat="yyyy-MM-dd"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  placeholderText="Select end date"
                />
              </div>

              {/* Manager input */}
              <div>
                <label className="block text-sm font-medium text-gray-700">Manager</label>
                <input
                  type="text"
                  name="manager"
                  value={filters.manager}
                  onChange={handleFilterChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
                  placeholder="Search manager..."
                />
              </div>

              {/* Venue input */}
              <div>
                <label className="block text-sm font-medium text-gray-700">Venue</label>
                <input
                  type="text"
                  name="venue"
                  value={filters.venue}
                  onChange={handleFilterChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm"
                  placeholder="Search venue..."
                />
              </div>
            </div>
          </div>
        )}

          
          <div>
            {error ? (
              <p className="text-red-600">{error}</p>
            ) : isTokenLoaded ? (
              <CustomerSurveysTable filters={filters} />
            ) : (
              <p>Loading surveys...</p>
            )}
          </div>
        </ComponentCard>
      </div>
    </>
  );
};

export default CustomerSurveys;
